import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import api_rest from '../api_rest';

interface LoginResponse {
    accessToken: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthApiService {
    API_URI = api_rest.server.API_URI_TI;
    private tokenKey = 'authToken';

    constructor(private http: HttpClient, private router: Router) {
    }

    login(tipoConexion: string, idConexion: string, password: string): Observable<boolean> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        const body = {
            tipoConexion: tipoConexion,
            idConexion: idConexion,
            password: password,
            recaptcha_disable: true,
            recaptchaToken: null
        };

        return this.http.post<LoginResponse>(`${this.API_URI}/auth/login`, body, { headers }).pipe(
            map(response => {
                localStorage.setItem(this.tokenKey, response.accessToken);
                return true;
            }),
            catchError(error => {
                const errorMsg = this.handleError(error);
                console.error("AuthApiService / login - Error generado", errorMsg);
                return throwError(() => new Error(errorMsg));
            })
        );
    }

    private handleError(error: any): string {
        console.error('Error en la solicitud:', error);

        if (error.status === 0) {
            return 'Error de conexión: No se pudo conectar al servidor.';
        } else if (error.status === 400) {
            return 'Error en la solicitud: Datos inválidos.';
        } else if (error.status === 401) {
            return 'Error de autenticación: Credenciales incorrectas.';
        } else if (error.status === 500) {
            return 'Error del servidor: Inténtelo de nuevo más tarde.';
        } else {
            return 'Error desconocido: Inténtelo de nuevo.';
        }
    }

    isAuthenticated(): boolean {
        return !!localStorage.getItem(this.tokenKey);
    }

    getToken(): string | null {
        return localStorage.getItem(this.tokenKey);
    }

    logout(): void {
        localStorage.removeItem(this.tokenKey);
        this.router.navigate(['/login']);
    }
}